module.exports = __webpack_public_path__ + "img/70.b8ebc4e8.jpg";